module.exports = __webpack_public_path__ + "img/banner.236cea43.png";